var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("header"),_vm._v(" "),_vm._l((_vm.sortedData),function(items,sort_key){return [_vm._t("category-header",null,{sort_key:sort_key}),_vm._v(" "),_vm._t("card",null,{items:items})]})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/card/card.vue